import './App.css';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { messaging } from './config/firebase';
import { isSupported, getToken } from 'firebase/messaging';
import secureAxios from './utils/secureAxios';
import { FavoritesProvider } from './hooks/useFavorites';
import Logout from './pages/Logout/Logout';
import Login from './pages/Login/Login'
import Home from './pages/Home/Home';
import Register from './pages/Register/Register';
import Profile from './pages/Profile/Profile';
import Categories from './pages/Categories/Categories';
import Chat from './pages/Chat/Chat';
import MyProducts from './pages/MyProducts/MyProducts';
import AddProduct from './pages/AddProduct/AddProduct';
import CategoryPage from './pages/CategoryPage/CategoryPage';
import CartPage from './pages/CartPage/CartPage';
import ProductInfoWrapper from './utils/ProductInfoWrapper/ProductInfoWrapper';
import UserChat from './pages/UserChat/UserChat';
import Favorites from './pages/Favorites/Favorites';
import EditProduct from './pages/EditProduct/EditProduct';
import OrdersPage from './pages/OrdersPage/OrdersPage';
import AdminDash from './pages/AdminDash/AdminDash';
import AdminPartners from './pages/AdminPartners/AdminPartners';
import ProviderRequest from './pages/ProviderRequest/ProviderRequest';
import Plans from './pages/Plans/Plans';
import MyOrders from './pages/MyOrder/MyOrders';
import SearchPage from './pages/SearchPage/SearchPage';
import TermsAndConditions from './pages/TermsAndConditions/TermsAndConditions';
import PrivacyPolicy from './pages/PrivacyPolicy/PrivacyPolicy';
import ContactoEliminacion from './pages/ContactoEliminacion/ContactoEliminacion';
import OrderInfo from './pages/OrderInfo/OrderInfo';
import NewOrder from './pages/NewOrder/NewOrder';
// import PDF from './pages/PDF/PDF';
import PaymentStatus from './pages/PaymentStatus/PaymentStatus';
import MyCustomers from './pages/MyCustomers/MyCustomers';
import useSessionManager from './hooks/useSessionManager';
import ServicioCliente from './pages/ServicioCliente/ServicioCliente';
import Catalog from './pages/Catalog/Catalog';
import ProviderProfile from './pages/ProviderProfile/ProviderProfile';
import Configuracion from './pages/Configuracion/Configuracion';
import CatalogoPrivadoIframe from './pages/CatalogoPrivadoIframe/CatalogoPrivadoIframe';
import CartPrivado from './pages/CartPrivado/CartPrivado';
import RecuperarContrasena from './pages/RecuperarContrasena/RecuperarContrasena';
import RegisterProvider from './pages/RegisterProvider/RegisterProvider';
import CambiarContrasena from './pages/CambiarContrasena/CambiarContrasena';
import EditInventory from './pages/EditInventory/EditInventory';
import InventoryOverview from './pages/InventoryOverview/InventoryOverview';
import ProviderDebtReport from './pages/ProviderDebtReport/ProviderDebtReport';
import DebtOperation from './pages/DebtOperation/DebtOperation';
import Points from './pages/Points/Points';
import SAI from './pages/SAI/SAI';
import MisProveedores from './pages/MisProveedores/MisProveedores';
import SAIHelp from './pages/SAIHelp/SAIHelp';
import SubscriptionCheckout from './pages/SubscriptionCheckout/SubscriptionCheckout';
import PlanSelection from './pages/PlanSelection/PlanSelection';
import PrivateCatalogManager from './components/PrivateCatalogManager/PrivateCatalogManager';
import PublicCatalogWrapper from './utils/PublicCatalogWrapper';
import TemporaryOrderWrapper from './utils/TemporaryOrderWrapper';
import OviCatalogosLanding from './pages/OviCatalogosLanding/OviCatalogosLanding';
import LoginOvi from './pages/LoginOvi/LoginOvi';
import RegisterOvi from './pages/RegisterOvi/RegisterOvi';
import PDFPreviewPage from './pages/PDFPreviewPage';
import GenerateInvoicePage from './pages/GenerateInvoicePage';

const titles = {
  '/': 'Inicio - Minymol',
  '/login': 'Iniciar sesión - Minymol',
  '/logout': 'Cerrar sesión - Minymol',
  '/register': 'Registrarse - Minymol',
  '/profile': 'Perfil - Minymol',
  '/categories': 'Categorías - Minymol',
  '/messages': 'Chat - Minymol',
  '/my-products': 'Mis productos - Minymol',
  '/add-product': 'Agregar producto - Minymol',
  '/cart': 'Carrito - Minymol',
  '/user-chat': 'Chat de usuario - Minymol',
  '/favorites': 'Favoritos - Minymol',
  '/my-orders': 'Mis pedidos - Minymol',
  '/admin': 'Panel de administración - Minymol',
  '/solicitud': 'Solicitar ser proveedor - Minymol',
  '/mis-pedidos': 'Mis pedidos - Minymol',
  '/condiciones': 'Condiciones de uso - Minymol',
  '/politica': 'Política de privacidad - Minymol',
  '/contacto': 'Eliminación de cuenta - Minymol',
  '/orden': 'Información de pedido - Minymol',
  '/nueva-orden': 'Nueva orden - Minymol',
  '/my-customers': 'Mis clientes - Minymol',
  '/servicio': 'Servicio al cliente - Minymol',
  '/my-store': 'Mi tienda - Minymol',
  '/subscribe': 'Suscripción - Minymol',
  '/plans-selection': 'Seleccionar Plan - Minymol',
  '/my-private-catalog': 'Mi Catálogo Privado - Minymol',
  '/private-catalog': 'Catálogo Privado - Minymol',
  '/temporary-order': 'Pedido Temporal - Minymol',
  '/ovicatalogos-landing': 'OviCatalogos - Catálogos Inteligentes',
  '/loginovi': 'Iniciar Sesión - OviCatalogos',
  '/registerovi': 'Registrarse - OviCatalogos',
};

const vapidKey = 'BL9Hx_1JRfrSusv698qSJJBpIEdSRlz0JLkBblwSxRx6jOai8OIc0enx6KEfQ2KKa2smi4TscsZJ-fv4HJqbjM0';

const TitleUpdater = () => {
  const location = useLocation();

  useEffect(() => {
    const basePath = location.pathname.split('/')[1] ? `/${location.pathname.split('/')[1]}` : '/';
    document.title = titles[basePath] || 'Minymol';
  }, [location]);

  return null;
};

// Componente para guardar la ruta actual en localStorage
const RouteTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Guardar la ruta completa para que index.html pueda restaurarla
    const fullUrl = window.location.origin + location.pathname + location.search;
    
    // Siempre guardar la ruta, sin importar si estamos en iframe o no
    localStorage.setItem('ovi_iframe_route', fullUrl);
    console.log('📍 Ruta guardada:', fullUrl);
    
    // Si estamos en un iframe, también enviar mensaje al padre
    try {
      if (window.self !== window.top && window.parent) {
        window.parent.postMessage({
          type: 'route-change',
          route: fullUrl
        }, '*');
      }
    } catch (e) {
      // Ignorar errores de cross-origin
      console.log('No se pudo enviar mensaje al padre (cross-origin)');
    }
  }, [location]);

  return null;
};

function App() {
  useEffect(() => {
    const verificarToken = async () => {
      const activado = localStorage.getItem('notificaciones-activadas');
      const rechazado = localStorage.getItem('notificaciones-rechazadas');

      // Solo continuar si el usuario no rechazó y ya dio permisos al navegador
      if (Notification.permission === 'granted' && activado && !rechazado) {
        const soportado = await isSupported();
        if (!soportado) return;

        try {
          const token = await getToken(messaging, { vapidKey });
          if (token) {
            await secureAxios.post('https://api.minymol.com/notifications/register-token', {
              fcmToken: token,
            });
            console.log('📲 Token FCM verificado y enviado');
          }
        } catch (err) {
          console.error('❌ Error verificando token FCM:', err);
        }
      }
    };

    verificarToken();
  }, []);
  useSessionManager();
  return (
    <FavoritesProvider>
      <Router>
        <TitleUpdater />
        <RouteTracker />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/logout" element={<Logout />} />
          <Route path="/register" element={<Register />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/categories" element={<Categories />} />
          <Route path="/messages" element={<Chat />} />
          <Route path="/my-products" element={<MyProducts />} />
          <Route path="/add-product" element={<AddProduct />} />
          <Route path="/sub-category/:subCategorySlug" element={<CategoryPage />} />
          <Route path="/category/:categorySlug" element={<CategoryPage />} />
          <Route path="/product/:uuid" element={<ProductInfoWrapper />} />
          <Route path="/cart" element={<CartPage />} />
          <Route path="/messages/user-chat/:id" element={<UserChat />} />
          <Route path="/favorites" element={<Favorites />} />
          <Route path="/edit-product/:uuid" element={<EditProduct />} />
          <Route path="/my-orders" element={<OrdersPage />} />
          <Route path="/admin" element={<AdminDash />} />
          <Route path="/admin/partners" element={<AdminPartners />} />
          <Route path='/solicitud' element={<ProviderRequest />} />
          <Route path='/plans/:token' element={<Plans />} />
          <Route path='/mis-pedidos' element={<MyOrders />} />
          <Route path="/buscar/:text" element={<SearchPage />} />
          <Route path="/condiciones" element={<TermsAndConditions />} />
          <Route path="/politica" element={<PrivacyPolicy />} />
          <Route path="/contacto" element={<ContactoEliminacion />} />
          <Route path="/orden/:uuid" element={<OrderInfo />} />
          <Route path='/nueva-orden' element={<NewOrder />} />
          {/* <Route path='/orden/pdf/:orderId' element={<PDF />} /> */}
          <Route path="/planes/:status" element={<PaymentStatus />} />
          <Route path='/my-customers' element={<MyCustomers />} />
          <Route path='/servicio' element={<ServicioCliente />} />
          <Route path="/catalog/:id" element={<Catalog />} />
          <Route path="/my-store" element={<ProviderProfile />} />
          <Route path='/configuracion' element={<Configuracion />} />
          <Route path="/catalogo-privado-iframe" element={<CatalogoPrivadoIframe />} />
          <Route path='/carrito-privado' element={<CartPrivado />} />
          <Route path="/recuperar-contrasena" element={<RecuperarContrasena />} />
          <Route path="/solicitud-proveedor" element={<RegisterProvider />} />
          <Route path="/cambiar-contrasena" element={<CambiarContrasena />} />
          <Route path="/edit-inventory" element={<EditInventory />} />
          <Route path="/inventory-overview" element={<InventoryOverview />} />
          <Route path="/informe-deudas" element={<ProviderDebtReport />} />
          <Route path="/movimientos" element={<DebtOperation />} />
          <Route path="/points" element={<Points />} />
          <Route path="/sai" element={<SAI />} />
          <Route path="/mis-proveedores" element={<MisProveedores />} />
          <Route path="/sai-help" element={<SAIHelp />} />
          <Route path="/subscribe/:planSlug" element={<SubscriptionCheckout />} />
          <Route path="/subscribe" element={<SubscriptionCheckout />} />
          <Route path="/plans-selection" element={<PlanSelection />} />

          {/* Rutas para Catálogos Privados */}
          <Route path="/my-private-catalog" element={<PrivateCatalogManager />} />
          <Route path="/private-catalog/:catalogId/:providerId" element={<PublicCatalogWrapper />} />
          <Route path="/temporary-order/:token" element={<TemporaryOrderWrapper />} />

          {/* Ruta para OviCatalogos Landing */}
          <Route path="/ovicatalogos-landing" element={<OviCatalogosLanding />} />

          {/* Rutas para OviCatalogos Auth (para iframes) */}
          <Route path="/loginovi" element={<LoginOvi />} />
          <Route path="/registerovi" element={<RegisterOvi />} />

          {/* Ruta para desarrollo de PDFs */}
          <Route path="/pdf-preview" element={<PDFPreviewPage />} />
          
          {/* Ruta para generar cuenta de cobro FlyMarket */}
          <Route path="/generar-cuenta-cobro" element={<GenerateInvoicePage />} />
        </Routes>
      </Router>
    </FavoritesProvider>
  );
}

export default App;
